import type React from 'react';
import { createContext } from 'react';

import { type AppCustomProps, defaultCustomProps } from '..';

export const CustomPropsContext =
  createContext<AppCustomProps>(defaultCustomProps);

export const CustomPropsProvider: React.FC<{
  children?: React.ReactNode;
  basePath?: string;
}> = ({ children, ...props }) => (
  <CustomPropsContext.Provider value={{ ...defaultCustomProps, ...props }}>
    {children}
  </CustomPropsContext.Provider>
);
